import React from 'react';
import { connect } from 'react-redux';
import ServiciosForm from './servicios.frm';

const mapDispatch = (dispatch) => {
    return {
    	resetDatos() {
            dispatch({ "type" : "DIRECTORIO_RESET_FORM" });
        },
    	guardarDatos(sData) {
            dispatch({ "type" : "DIRECTORIO_SERVICIOS_FORM", "servicios": sData });
        },
        pasoSiguiente(_paso) {
            dispatch({ "type" : "DIRECTORIO_PASO_SIGUIENTE"});
        },
        tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
    }
}

class Servicios extends React.Component {
	
	componentWillMount = () => {
		this.props.resetDatos();
	}
	
	submit = (data) => {
		if(data.servicio == "medicos"){
			this.props.tagManager({ "type": "EVENT_DIRECTORIOS_MEDICOS-CONVENIO" });	
		}
		else if(data.servicio == "hospitales"){
			this.props.tagManager({ "type": "EVENT_DIRECTORIOS_HOSPITALES-CONVENIO" });	
		}
	    return new Promise(resolve => {
	    	this.props.guardarDatos(data.servicio);
	        this.props.pasoSiguiente();
    		resolve();
	    });
	}

	render() {
		return <ServiciosForm onSubmit={this.submit} />;
	}
}

export default connect(null, mapDispatch)(Servicios);


// WEBPACK FOOTER //
// ./src/directorio/servicios.cmpt.js